import { useState } from "react";
import { useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";

export default function useParamsHandler() {
  const [searchParams, setSearchParams] = useSearchParams();
  const LoggedInUser = useSelector(state => state.user?.UserName);
  const params = useParams();
  const [systemId, setSystemId] = useState(params.systemId);

  const getCurrentLayout = layoutList => {
    let defaultLayout = searchParams.get("layout");
    if (defaultLayout) {
      defaultLayout = layoutList.find(layout => layout.ID === defaultLayout);
    }
    const layouts = sortLayoutBasedOnUsrName(layoutList);
    return { defaultLayout, layouts };
  };

  const sortLayoutBasedOnUsrName = layoutList => {
    //sort based on name and then based on active home layout
    layoutList.sort((item1, item2) => item1.Username.localeCompare(item2.Username) || item2.Home - item1.Home);
    const currentUserList = [];
    const restUsersList = [];
    //sort based of current loggedin user from list sorted based on name and Home layout
    layoutList.forEach(element => {
      if (element.Username.toLowerCase() === LoggedInUser.toLowerCase()) {
        currentUserList.push(element);
      } else {
        restUsersList.push(element);
      }
    });
    return [...currentUserList, ...restUsersList];
  };

  const getSystemId = () => systemId;

  return { getCurrentLayout, getSystemId, sortLayoutBasedOnUsrName };
}
